module.exports = __webpack_public_path__ + "assets/logo_fundky_white@2x.png";